import { Steps } from 'antd';
import styled from 'styled-components';

export const StyledAntdCartSteps = styled(Steps)`
  padding-left: 20px;
  padding-right: 5px;
  height: 34px;
  padding-top: 0 !important;
  margin-bottom: 15px;

  .ant-steps-item {
    .ant-steps-item-container {
      padding-bottom: 0;
      align-items: center;
      display: flex;

      .ant-steps-item-icon {
        font-size: 22px;
        margin-right: 20px;
        height: 34px;
        width: 34px;
      }

      .ant-steps-item-content {
        .ant-steps-item-title {
          font-size: 16px;
          font-family: ${({ theme }) => theme.fontText};
          color: ${({ theme }) => theme.black};
        }
      }
    }

    &::before {
      display: none !important;
    }

    &::after {
      top: calc(50%) !important;
      border-top: 1px solid ${({ theme }) => theme.black} !important;
      border-inline-end: 1px solid ${({ theme }) => theme.black} !important;
    }
  }
`;
